"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  AppTracking: () => AppTracking
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_unavailable = require("./unavailable");
var hybrid;
function native() {
  if (import_react_native.Platform.OS !== "ios") throw new Error("AppTracking requires an iOS native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneAppTracking");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestPermission() {
  return native().requestPermission().catch(import_nativeError.rethrowNativeError);
}
var nativeAppTracking = Object.freeze({
  getPermissionStatus,
  requestPermission
});
var AppTracking = import_react_native.Platform.OS === "android" ? import_unavailable.AppTracking : nativeAppTracking;
//# sourceMappingURL=index.native.js.map
